export type PayrollTabId = 'allocate' | 'tips' | 'labor' | 'settings'

export const PAYROLL_TABS: ReadonlyArray<{ id: PayrollTabId; label: string }> = [
  { id: 'allocate', label: 'Allocate' },
  { id: 'tips', label: 'Tip calculator' },
  { id: 'labor', label: 'Labor analytics' },
  { id: 'settings', label: 'Settings' },
]
